"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PaymentMethods = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PaymentMethods = () => {
  return /*#__PURE__*/_react.default.createElement("div", {
    key: "BWMPaymentSignalCampaign",
    className: "payment-signal payment-signal-web"
  }, /*#__PURE__*/_react.default.createElement("span", {
    id: "siteseal",
    className: "siteseal"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://seal.godaddy.com/verifySeal?sealID=14QKJlaA2ETxPhyDMpyShalLrDiCNoPFulp18BbBwanq6g2M9fulppYLk9VD",
    target: "blank"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "SSL site seal - click to verify",
    src: "https://petcdnstore.blob.core.windows.net/qt-assets/Prod/Common/GoDaddy_siteseal.gif"
  }))), /*#__PURE__*/_react.default.createElement("span", {
    className: "band-logo"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "Payment signal logo",
    src: "https://petcdnstore.blob.core.windows.net/qt-assets/Prod/Common/payment-method-logo.png"
  })));
};
exports.PaymentMethods = PaymentMethods;
var _default = exports.default = PaymentMethods;